import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-license-exclusive',
  templateUrl: './license-exclusive.component.html',
  styleUrls: ['./license-exclusive.component.scss']
})
export class LicenseExclusiveComponent implements OnInit, OnChanges {
  @Input() CurrentLicenseData: any;
  currentLicense:any = '';
  currentData:any = '';
  currentDate:any = new Date();
  constructor(public commonServiceFunction: CommonService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['CurrentLicenseData']) {
        this.currentData = this.CurrentLicenseData;
        let priceArray: any = this.currentData?.currentBeatData?.prices;
        let found =  priceArray.find((item: any) => item.licence === this.currentData?.cartData?.beat_price?.licence?._id);
        if (found) {
          this.currentLicense = found;
        }
      }
  }

}
